module.exports = __webpack_public_path__ + "img/EKG_E2_A2.fe6eebec.jpg";